export default __webpack_public_path__ + "static/media/team.1116aab8.png";